import styled from 'styled-components'

import A from '@components/A'

export const StyledALink = styled(A)`
  text-transform: initial;
  letter-spacing: 0.5px;
  color: #b4a06e;
  font-size: 16px;
  &:hover {
    text-decoration: underline;
  }
`
